import { AVATAR_PRESET_COLORS, PRESET_COLORS } from '../constants/color.mjs';
import { AVATAR_PRESET_SIZES } from '../constants/size.mjs';

function isPresetColor(value) {
  return PRESET_COLORS.some((presetColor) => presetColor === value);
}
function isAvatarPresetColor(avatarColor) {
  return AVATAR_PRESET_COLORS.some(
    (avatarPresetColor) => avatarPresetColor === avatarColor
  );
}
function isAvatarPresetSize(avatarSize) {
  return AVATAR_PRESET_SIZES.some(
    (avatarPresetSize) => avatarPresetSize === avatarSize
  );
}

export { isAvatarPresetColor, isAvatarPresetSize, isPresetColor };
//# sourceMappingURL=cast.mjs.map
